module.exports = {
	"config": {
		"siteTitle": "myGNOME",
		"baseColor": "#00BCD4",
		"linkPrefix": "/myGNOME",
		"docPages": [
			"/docs/",
			"/docs/extensions/",
			"/docs/configuration/",
			"/docs/terminal/",
			"/docs/linux/",
			"/docs/ubuntu/"
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/home/alex/Projects/myGNOME-React/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/home/alex/Projects/myGNOME-React/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "contribute",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "contribute",
				"stem": "index",
				"path": "contribute/index.md",
				"absolute": "/home/alex/Projects/myGNOME-React/contribute/index.md",
				"isAbsolute": false
			},
			"requirePath": "contribute/index.md",
			"path": "/contribute/",
			"data": {
				"title": "Contribute"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx",
				"absolute": "/home/alex/Projects/myGNOME-React/docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/configuration",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/configuration",
				"stem": "index",
				"path": "docs/configuration/index.md",
				"absolute": "/home/alex/Projects/myGNOME-React/docs/configuration/index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/configuration/index.md",
			"path": "/docs/configuration/",
			"data": {
				"title": "Configuration"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/extensions",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/extensions",
				"stem": "index",
				"path": "docs/extensions/index.md",
				"absolute": "/home/alex/Projects/myGNOME-React/docs/extensions/index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/extensions/index.md",
			"path": "/docs/extensions/",
			"data": {
				"title": "Extensions"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs",
				"stem": "index",
				"path": "docs/index.md",
				"absolute": "/home/alex/Projects/myGNOME-React/docs/index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/index.md",
			"path": "/docs/",
			"data": {
				"title": "Get Started"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/linux",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/linux",
				"stem": "index",
				"path": "docs/linux/index.md",
				"absolute": "/home/alex/Projects/myGNOME-React/docs/linux/index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/linux/index.md",
			"path": "/docs/linux/",
			"data": {
				"title": "Linux Systems"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/terminal",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/terminal",
				"stem": "index",
				"path": "docs/terminal/index.md",
				"absolute": "/home/alex/Projects/myGNOME-React/docs/terminal/index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/terminal/index.md",
			"path": "/docs/terminal/",
			"data": {
				"title": "Terminal"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "docs/ubuntu",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "docs/ubuntu",
				"stem": "index",
				"path": "docs/ubuntu/index.md",
				"absolute": "/home/alex/Projects/myGNOME-React/docs/ubuntu/index.md",
				"isAbsolute": false
			},
			"requirePath": "docs/ubuntu/index.md",
			"path": "/docs/ubuntu/",
			"data": {
				"title": "GNOME on Ubuntu"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "explore",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "explore",
				"stem": "index",
				"path": "explore/index.md",
				"absolute": "/home/alex/Projects/myGNOME-React/explore/index.md",
				"isAbsolute": false
			},
			"requirePath": "explore/index.md",
			"path": "/explore/",
			"data": {
				"title": "Explore"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx",
				"absolute": "/home/alex/Projects/myGNOME-React/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 366
 ** module chunks = 0
 **/